module.exports = __webpack_public_path__ + "img/carousel.e8a9f0ca.svg";